import { createStyles, Flex, Tooltip, Text, Box } from '@mantine/core';
import { ChecklistIcon } from '../feedback/Checklist';
import { useMemo } from 'react';
import React from 'react';
import { useIsXs } from './hooks';
import { iconTypes } from '../feedback/Checklist';

const useStyles = createStyles(
  (
    theme,
    props: {
      icon: React.ComponentProps<typeof ChecklistIcon>['type'];
      useFilledCompareItem?: boolean;
    },
  ) => {
    const color = iconTypes[props.icon]?.color;
    const colorSplits = color?.split('.') || [];

    return {
      noOverflow: {
        overflow: 'hidden',
        overflowWrap: 'break-word',
        hyphens: 'auto',
      },
      container: {
        height: '100%',
        boxSizing: 'border-box',
        background: 'white',
        ...(!props.useFilledCompareItem || colorSplits.length !== 2
          ? {}
          : {
              background: theme.fn.rgba(theme.colors[colorSplits[0]][4], 0.2),
            }),
      },
    };
  },
);
// CompareListItem
export const CompareListItem = (
  props: {
    icon: React.ComponentProps<typeof ChecklistIcon>['type'];
    label: any;
    tooltip: any;
    iconSize?: number;
    useFilledCompareItem?: boolean;
  } & React.ComponentProps<typeof Flex>,
) => {
  const { icon, label, tooltip, iconSize, useFilledCompareItem, ...rest } =
    props;

  const { classes } = useStyles({
    icon,
    useFilledCompareItem: useFilledCompareItem,
  });

  const Renderer = useMemo(
    () =>
      !tooltip
        ? ({ children }) => children
        : ({ children }) => (
            <Tooltip offset={0} label={tooltip}>
              {children}
            </Tooltip>
          ),
    [tooltip],
  );

  const isXs = useIsXs();
  const defaultSize = isXs ? 20 : 28;

  const numericIconSize = props.iconSize || defaultSize;
  const pxIconsSize = `${numericIconSize}px`;

  return (
    <Renderer>
      <Flex
        py="sm"
        gap={0}
        sx={{ flexDirection: 'column', alignItems: 'center' }}
        className={classes.container}
        data-testid="compare-list-item"
        {...rest}
      >
        {(icon || tooltip) && (
          <Box
            sx={{
              lineHeight: 1,
              transform: !tooltip
                ? null
                : `translateX(${numericIconSize / 2}px)`,
            }}
          >
            <>
              {icon && <ChecklistIcon size={pxIconsSize} type={icon} />}
              {tooltip && <ChecklistIcon size={pxIconsSize} type="question" />}
            </>
          </Box>
        )}
        {label && (
          <Text
            px="xs"
            maw="100%"
            size="sm"
            ta="center"
            className={classes.noOverflow}
          >
            {label}
          </Text>
        )}
      </Flex>
    </Renderer>
  );
};
